/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_hw_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Find the healthy weight range for your height, based on a normal BMI of 18.5 to 24.9.`)
};

const es_hw_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Encuentra el rango de peso saludable para tu altura, basado en un IMC normal de 18,5 a 24,9.`)
};

const de_hw_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Finden Sie den gesunden Gewichtsbereich für Ihre Größe, basierend auf einem normalen BMI von 18,5 bis 24,9.`)
};

const nl_hw_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zoek het gezonde gewichtsbereik voor uw lengte op, op basis van een normale BMI van 18,5 tot 24,9.`)
};

const fr_hw_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trouvez la plage de poids santé pour votre taille, basée sur un IMC normal de 18,5 à 24,9.`)
};

const it_hw_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trova l'intervallo di peso sano per la tua altezza, basato su un BMI normale da 18,5 a 24,9.`)
};

const pt_br2_hw_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Encontre a faixa de peso saudável para sua altura, com base em um BMI normal de 18,5 a 24,9.`)
};

const pt_hw_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Encontre o intervalo de peso saudável para a sua altura, com base num IMC normal de 18,5 a 24,9.`)
};

const ja_hw_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正常なBMI 18.5～24.9に基づいて身長の健康的な体重範囲を確認してください。`)
};

const zh_hw_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`根据 18.5 至 24.9 的正常 BMI 范围，找到您身高对应的健康体重范围。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const hw_intro = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.hw_intro(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("hw_intro", locale)
	if (locale === "en") return en_hw_intro(inputs)
	if (locale === "es") return es_hw_intro(inputs)
	if (locale === "de") return de_hw_intro(inputs)
	if (locale === "nl") return nl_hw_intro(inputs)
	if (locale === "fr") return fr_hw_intro(inputs)
	if (locale === "it") return it_hw_intro(inputs)
	if (locale === "pt-BR") return pt_br2_hw_intro(inputs)
	if (locale === "pt") return pt_hw_intro(inputs)
	if (locale === "ja") return ja_hw_intro(inputs)
	return zh_hw_intro(inputs)
};